module.exports = __webpack_public_path__ + "img/7.ef68b099.jpg";